module.exports = __webpack_public_path__ + "img/img_main_tit.e18adc92.png";